import { Skeleton, Stack } from '@mantine/core';
import { memo } from 'react';

export const QuestionContentSkeleton = memo(() => (
	<Stack>
		<Skeleton height={40} width="100%" />
	</Stack>
));
